import { render, staticRenderFns } from "./order-detail.vue?vue&type=template&id=12528952&scoped=true&"
import script from "./order-detail.js?vue&type=script&lang=js&"
export * from "./order-detail.js?vue&type=script&lang=js&"
import style0 from "./order-detail.scss?vue&type=style&index=0&id=12528952&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12528952",
  null
  
)

export default component.exports